<template>
  <div class="basic_con">
    <Frame title="客户跟进">
      <template slot="contentSlot">
        <div class="con_wrapper" v-if="tableData.length>0">
          <el-timeline :reverse="reverse">
            <el-timeline-item
              v-for="(activity, index) in tableData"
              :key="index"
            >
              <span class="follow_size">
                {{ activity.visitTime }}
              </span>
              <span class="btn follow_size follow_name">
                {{ activity.visitPeopleNames }}
              </span>
              <span class="follow_size"> 拜访 </span>
              <span class="btn follow_size">
                {{ activity.companyUser }}
              </span>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="con_wrapper_" v-else>
           <a-empty description="未查询到相关数据" />
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "../../frame.vue";
import { getList, deleteVisit, getDemandList } from "@/api/zd/visit";
export default {
  name: "followUp",
  components: {
    Frame,
  },
  data() {
    return {
      reverse: true,
      tableData: [],
      activities: [
        {
          x: "赵小刚",
          y: "张三",
          timestamp: "2018-04-15",
        },
        {
          x: "赵小刚",
          y: " 张三",
          timestamp: "2018-04-15",
        },
        {
          x: "赵小刚",
          y: "张三、李四",
          timestamp: "2018-04-15",
        },
      ],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 999,
      },
    };
  },
  mounted() {
    this.queryTableData();
  },
  methods: {
    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        custId: this.$route.params.id,
      };
      let res = await getList(params);
      if (res.data.code == 200) {
        let data = res.data.data.list;
        // data.map((item) => {
        //   return {
        //     ...item,
        //     visitPeopleNamesList: item.visitPeopleNames
        //       ? item.visitPeopleNames.split(",")
        //       : [],
        //   };
        // });
        this.tableData = data;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
  height: 397px;
}
.con_wrapper {
  padding-top: 30px;
  height: 310px;
  overflow: scroll;
}
.con_wrapper_ {
  display: flex;
  justify-content: center;
  align-items: center;
  height:250px;
}
/deep/ .el-timeline {
  padding-inline-start: 20px;
}
.follow_size {
  font-size: 14px;
}
.follow_name {
  padding-left: 4px;
}
.btn {
  font-weight: 400;
  color: #409eff;
  cursor: pointer;
}
/deep/ .el-timeline-item__node {
  border: 3px solid #409eff;
  background-color: #ffffff;
}
</style>

